module.exports = __webpack_public_path__ + "static/media/table-m.50970c9b.png";